import type { ProxyNativeModule } from 'expo-modules-core';

import type { NotificationResponse } from './Notifications.types';

export interface NotificationsEmitterModule extends ProxyNativeModule {
  getLastNotificationResponse?: () => NotificationResponse | null;
  clearLastNotificationResponse?: () => void;
}
